module.exports = __webpack_public_path__ + "img/t2-17.e8795ec4.svg";